import { withRetry, WithRetryOptions } from "../../../../utils";
import { RoomDelegator } from "../RoomDelegator";
import { RoomValidationError } from "./RoomValidationError";
import { RoomValidatorResult } from "./types";

export const DEFAULT_VALIDATE_ROOM_HAS_PARTICIPANTS_RETRY_OPTIONS = {
  retries: 4,
  initialDelayMs: 250,
};

/**
 * Checks that the room has at least one remote participant
 */
export async function validateRoomHasParticipants(
  room: RoomDelegator,
  retryOptions: WithRetryOptions = DEFAULT_VALIDATE_ROOM_HAS_PARTICIPANTS_RETRY_OPTIONS,
): Promise<RoomValidatorResult> {
  // Check again after a delay, sometimes it takes a moment for the
  // information to propagate
  return await withRetry(async () => {
    if (room.remoteParticipants.size < 1) {
      throw new RoomValidationError("empty-room");
    }
  }, retryOptions)()
    .then(() => [true] satisfies RoomValidatorResult)
    .catch(
      (error: RoomValidationError) =>
        [false, error] satisfies RoomValidatorResult,
    );
}
